const wait = ({ milliseconds }: { milliseconds: number }) => {
    return new Promise<void>((resolve) => {
        setTimeout(resolve, milliseconds);
    });
};

export const DelayUtils = {
    wait,
};
